/* globals toggleClass */

// Funzione Padosoft gestione della confezione regalo e del biglietto di auguri
function setRegalo() {
  let $params = 'set_regalo=true';
  if ($('#confRegStandard').is(':checked') || $('#confRegMateriale').is(':checked') || $('#confRegNatale').is(':checked')) {
    $params += '&regalo=1';
    if ($('#confRegMateriale').is(':checked')) {
      $params += '&materiale_confezione=1';
    } else {
      $params += '&materiale_confezione=0';
    }

    if ($('#confRegNatale').is(':checked')) {
      $params += '&confezione_natale=1';
    }

  } else if (parseInt($('#regalo-elegance').val(), 10) === 1) {
    $params += '&regalo=1&confezione_elegance=1';
  } else {
    $params += '&regalo=0';
  }

  // Imposto il tipo di confezione scelta
  const tipoConfezione = $('.gift-type-radio:checked').val();
  $params += tipoConfezione ? `&tipo_confezione=${tipoConfezione}` : '&tipo_confezione=nessuna';

  // Passo l'eventuale biglietto regalo
  $params += '&documenti_testa_note_interne=' + $('#documenti_testa_note_interne').val();

  $.ajax({
    data: $params,
    cache: false,
    url: '/secure/sum_up.php'
  });
}


/**
 * ============================================================================
 * Configuratore della confezione regalo
 * ============================================================================
 */
const giftTypes = document.querySelectorAll('.gift-type');
const giftTypeImages = document.querySelectorAll('.gift-type-image');
const giftTypeRadios = document.querySelectorAll('.gift-type-radio');

// Gestisco la selezione della confezione regalo.
if (giftTypes) {
  giftTypes.forEach((type) => {
    type.addEventListener('click', () => {
      giftTypeImages.forEach(el => el.classList.remove('selected'));
      const typeImage = type.querySelector('.gift-type-image');
      const typeRadio = type.querySelector('.gift-type-radio');
      typeImage.classList.add('selected');
      typeRadio.checked = true;
      typeRadio.dispatchEvent(new Event('change'));
    });
  });
}

// Al cambio di selezione attivo la routine per salvare la scelta
giftTypeRadios.forEach(radio => radio.addEventListener('change', () => setRegalo()));


// Al cambio del radio della confezione regalo controllo se è selezionata e nel
// caso mostro la textarea per per l'inserimento del biglietto di auguri. In
// ogni caso avvio la funzione di gestione della confezione regalo.
$('#cart-confezione-regalo .radio').on('change', function () {
  if ($(this).attr('id') === 'confRegNoGrazie') {
    $('.cntConfezioneRegalo').addClass('hidden');
  } else {
    $('.cntConfezioneRegalo').removeClass('hidden');
  }
  setRegalo();
});

// Gestione del biglietto regalo
$('#documenti_testa_note_interne').on('change', function () {
  setRegalo();
});

if (document.getElementById('cart-container')) {

  // Gestione area confezione regalo
  const $cartGift = document.getElementById('cart-gift-options');
  const $cartGiftTitle = document.getElementById('cart-gift-title');
  $cartGiftTitle.addEventListener('click', () => toggleClass($cartGift, 'hidden'));

  // Gestione area inserimento coupon
  const $cartCoupon = document.getElementById('cart-coupon');
  const $cartCouponTitle = document.getElementById('cart-coupon-title');
  $cartCouponTitle.addEventListener('click', () => toggleClass($cartCoupon, 'open'));

  // Rimuovo il coupon al click sul pulsante relativo
  const removeCoupon = document.getElementById('remove-coupon');
  if (removeCoupon) {
    removeCoupon.addEventListener('click', function () {
      document.getElementById('frm_coupon').submit();
    });
  }
}
